<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="170px">
        <!--
        required
        :rules="{ required: true, message: '请上传属性图标', trigger: 'change' }" -->
      <el-form-item
        label="属性图标"
        prop="icon2"
      >
        <uploadImg v-model="form.icon" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="介绍" prop="introduce">
        <uploadImg
          v-model="form.introduce"
          :imgSize="1"
          :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
        ></uploadImg>
      </el-form-item>
      <el-form-item label="颜色" prop="color">
        <el-color-picker v-model="form.color"></el-color-picker>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="form.type" clearable placeholder="请选择类型">
          <el-option v-for="item in typeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item label="副标题" prop="subtitle">
        <el-input :rows="2" placeholder="请输入副标题" v-model="form.subtitle"></el-input>
      </el-form-item>
    </el-form>
    <div class="footer" v-if="!editorialJudgment">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getCreate('form')">确 定</el-button>
    </div>
    <div class="footer" v-if="editorialJudgment">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getModify('form')">确 定</el-button>
    </div>
  </d2-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { addAtt, editAtt, attDetailInfo } from '@/api/demo/attributes/index'
import uploadImg from '@/components/uploadImage/index.vue'
export default {
  components: {
    uploadImg
  },
  name: 'addAttributes',
  data () {
    return {
      radio: '1',
      tableKey: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        keyword: ''
      },
      form: {
        icon: '',
        icon2: [], // 封面图
        color: null, // 颜色
        subtitle: null, // 副标题
        name: null, // 名称
        type: null, // 类型
        introduce: '', // 介绍
        introduce2: []
      },
      typeList: [
        {
          key: 1,
          value: '亲密关系'
        },
        {
          key: 2,
          value: '气质特征'
        },
        {
          key: 3,
          value: '基础'
        },
        {
          key: 4,
          value: '能力'
        },
        {
          key: 5,
          value: '影响力'
        }
      ],
      rules: {
        color: [
          {
            required: true,
            message: '请选择颜色',
            trigger: 'change'
          }
        ],
        subtitle: [
          {
            required: true,
            message: '请输入副标题',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'change'
          }
        ]
      },
      editorialJudgment: false // 判断新增或者编辑
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  created () {
    let that = this
    this.getId = this.$route.query.id
    if (this.getId != undefined) {
      that.editorialJudgment = true
      that.getListArr()
    } else if (this.getId == undefined) {
      that.editorialJudgment = false
    }
  },
  mounted () {},
  methods: {
    getListArr () {
      let that = this
      attDetailInfo(that.getId).then(res => {
        that.form = res
        console.log('that.form', that.form)
      })
    },
    // 开始时间
    dataSearch (e) {
      this.form.startTime = e
      console.log('e', this.form.startTime)
    },
    // 结束时间
    dataEnd (e) {
      this.form.endTime = e
      console.log('e', this.form.endTime)
    },
    // 新增
    getCreate (formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          addAtt(that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/attributes')
          })
        }
      })
    },
    // 编辑确定
    getModify (formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          editAtt(this.form, this.getId).then(res => {
            that.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/attributes')
          })
        }
      })
    },
    // 取消
    cancel (formName) {
      this.$router.push('/demo/attributes')
    }
  }
}
</script>
<style scoped>
.footer {
  text-align: center;
  margin-top: 30px;
}
.el-dialog__footer {
  display: flex;
}
</style>
